/**
 * Admin Utilities - Centralized admin management
 * 
 * Phase 1 Fix: Single source of truth for admin email lists
 * Prevents drift between client, server, and environment configurations
 */

// Centralized admin email list - must match firestore.rules exactly
export const ADMIN_EMAILS = [
  'razackcontehproj@gmail.com',
  'razackconteh@gmail.com',
  'omid.444@yahoo.com', 
  'omid.1996student@gmail.com',
  'info@wehearthem.com'
];

/**
 * Check if user email has admin privileges
 * @param {string} email - User email to check
 * @returns {boolean} True if user is admin
 */
export const isAdminUser = (email) => {
  if (!email || typeof email !== 'string') return false;
  return ADMIN_EMAILS.includes(email.trim().toLowerCase());
};

/**
 * Get admin emails from environment with fallback to centralized list
 * @returns {string[]} Array of admin emails
 */
export const getAdminEmails = () => {
  const envEmails = process.env.REACT_APP_WAITLIST_ADMIN_EMAILS;
  if (envEmails) {
    return envEmails.split(',').map(e => e.trim().toLowerCase());
  }
  return ADMIN_EMAILS;
};

/**
 * Check if current user is admin based on auth context
 * @param {Object} currentUser - Firebase auth user object
 * @returns {boolean} True if current user is admin
 */
export const isCurrentUserAdmin = (currentUser) => {
  return currentUser?.email ? isAdminUser(currentUser.email) : false;
};
